import { Box, Skeleton, Tooltip, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { tokens } from '../../../global/theme/tokens';
import useFetch from '../../../api/useFetch';
import UserStack from '../UserStack';
import { useTranslation } from 'react-i18next';
import { renderHours } from '../../../scenes/time-tracking/worktime';
import { API_GET, DBRequest, useConfig } from '../../../api/api';

export const CHROverview = ({
  projectId,
  data,
  className,
  onlyTotal,
  maxHeight = '150px',
  noBackground,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const config = useConfig();

  const { t } = useTranslation();

  //const { apiData } = useFetch(`projects/${projectId}/wage-presets`);
  const [apiData, setApiData] = useState(data ? data : null);

  useEffect(() => {
    if (!projectId) return;
    DBRequest({
      config,
      path: `projects/${projectId}/wage-presets`,
      method: API_GET,
      onResponse: setApiData,
    });
  }, [config]);

  //if (!apiData || apiData?.data.length === 0) return;
  return (
    <Box
      className={` rounded-lg w-full h-full ${className}`}
      sx={{ bgcolor: noBackground ? 'transparent' : colors.glass }}
    >
      <Box
        className="flex flex-col gap-2 overflow-y-auto pr-1"
        sx={{
          maxHeight,
        }}
      >
        <Typography fontWeight={500} className="opacity-60">
          {t('Hours')}
        </Typography>
        {apiData && apiData.data && apiData.data.length > 0 ? (
          apiData?.data.map((chr) => (
            <Box
              key={chr.id}
              className="flex justify-between items-center px-2 py-5 h-[36px]"
              sx={{
                backgroundColor: `${chr.color}30`,
                borderRadius: 3,
                border: `1px solid ${chr.color}80`,
                borderRight: `0px solid transparent`,
              }}
            >
              <Box className="flex gap-1 items-center">
                {chr.image && (
                  <img
                    className="w-[32px] h-[32px] object-contain"
                    src={chr.image.temporaryUrl}
                  />
                )}
                <Typography className="min-w-[100px]">{chr.label}</Typography>
              </Box>

              <Box className="flex items-center">
                <Box className="pr-2">
                  <UserStack users={chr.users || []} />
                </Box>
                <Tooltip title={t('Worked time')}>
                  <Typography fontWeight={600}>
                    {renderHours(chr.workedTimeSeconds / 60) + 'h'}
                  </Typography>
                </Tooltip>
                {!onlyTotal && (
                  <>
                    <Typography className="px-[3px]">{'/'}</Typography>
                    <Tooltip title={t('Planned time')}>
                      <Typography fontWeight={600}>
                        {renderHours(chr.plannedTimeSeconds / 60) + 'h'}
                      </Typography>
                    </Tooltip>
                    <Typography className="pl-1">
                      {`(${
                        chr.plannedTimeSeconds != 0
                          ? Math.round(
                              (chr.workedTimeSeconds / chr.plannedTimeSeconds) *
                                100
                            )
                          : 0
                      }%)`}
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          ))
        ) : (
          <Box className="flex justify-center items-center h-full">
            <Typography className="opacity-80">
              {t('No Calculative Hourly Rates found')}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
